module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-red-tiger.30536c36.png";